import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7846c22a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]

import { useProperties } from "@/composables/Property/useProperties";
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
import { ImmobilieStatus } from "@/models/immobilie/interfaces/IImmobilie";
import { capitalizeString } from "@/utilities/helper";
import { IonButton, IonIcon, IonItem, IonLabel, useIonRouter } from "@ionic/vue";
import {
    alertCircleOutline, archiveOutline, checkmarkCircleOutline, checkmarkDoneCircleOutline,
    chevronForwardOutline,
    ellipseOutline,
    playCircleOutline, timeOutline
} from "ionicons/icons";
import { computed, PropType } from "vue";
import { useI18n } from "vue-i18n";
import Immobilie from "../../models/immobilie.model";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyItem',
  props: {
  property: {
    type: Object as PropType<Immobilie>,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
},
  emits: ["open"],
  setup(__props, { emit }) {

const props = __props;




const router = useIonRouter()

const { t } = useI18n({ useScope: 'global' })
const { user } = useUser();
const featureFlags = computed(() => user.value?.organisation?.featureFlags);
const username = computed(() => {
    const name = props.property.verwalters && props.property.verwalters[0] && props.property.verwalters[0].username ? props.property.verwalters[0].username : ''
    const words = name.split(' ')
    const firstLetters = words.map((word: string) => word[0])
    return firstLetters.join('')
});
const store = useStore();
const isMobile = computed(() => {
    return store.getters["app/isMobile"];
});
const { changePerson, changeStatus  } = useProperties()
const statusIconState = computed(() => {
    switch(props.property.status) {
        case ImmobilieStatus.ANGELEGT: return ellipseOutline;
        case ImmobilieStatus.GEPLANT: return timeOutline;
        case ImmobilieStatus.IN_DURCHFUEHRUNG: return playCircleOutline;
        case ImmobilieStatus.ABGESCHLOSSEN: return checkmarkCircleOutline;
        case ImmobilieStatus.FREIGEGEBEN: return checkmarkDoneCircleOutline;
        case ImmobilieStatus.ARCHIVIERT: return archiveOutline;
        default: return alertCircleOutline
    }
});

async function openPropertyModal() {
    await store.dispatch("app/setOpenedPropertyId", props.property.id);
    if (!isMobile.value) {
        router.push({
            path: `/property/${props.property.id}`
        })
    }
}

function open() {
  emit("open");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    class: _normalizeClass({ 'selected-item': __props.selected }),
    onClick: open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLabel), {
        class: _normalizeClass(["p-2 md:p-4", { 'font-bold': __props.selected }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.property.externeObjektNr), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      (featureFlags.value?.property?.changeStatus)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "flex cursor-pointer p-4",
            title: _ctx.$t('immobilie.updateStatus'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => {$event.stopPropagation(); _unref(changeStatus)(__props.property, _unref(t))})
          }, [
            _createVNode(_unref(IonIcon), {
              class: "w-5 h-5 sm:w-8 sm:h-8",
              icon: statusIconState.value
            }, null, 8, ["icon"])
          ], 8, _hoisted_1))
        : _createCommentVNode("", true),
      (featureFlags.value?.property?.changePerson)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "flex personIcon cursor-pointer w-5 h-5 text-xs sm:w-8 sm:h-8 sm:text-base",
            title: _ctx.$t('immobilie.updatePerson'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($event.stopPropagation(), _unref(changePerson)(__props.property, _unref(t))))
          }, [
            _createElementVNode("div", null, _toDisplayString(username.value), 1)
          ], 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonButton), {
        fill: "clear",
        class: "mr-0 sm:mr-1",
        onClick: _withModifiers(openPropertyModal, ["stop"])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            class: "w-5 h-5 sm:w-8 sm:h-8",
            title: _unref(capitalizeString)(_unref(t)('immobilie.oeffnen')),
            icon: _unref(chevronForwardOutline)
          }, null, 8, ["title", "icon"])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})